module.exports = require('../impls/$for-each/for-each.js').forEach;